var _rect, _style, _use, _use2, _g, _g2, _use3, _use4, _use5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExample2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 338 173",
    fill: "none",
    width: 338,
    height: 173,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 173,
    fill: "#3A4149"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                .st0 {\r\n                        display: none;\r\n                        fill: none;\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 2;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st1 {\r\n                        fill: #6B9994;\r\n                }\r\n\r\n                .st12 {\r\n                        fill: #6E625E;\r\n                }\r\n\r\n                .st2 {\r\n                        fill: #4CB0D3;\r\n                }\r\n\r\n                .st3 {\r\n                        fill: #FAF9F7;\r\n                }\r\n\r\n                .st4 {\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 1.5;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st5 {\r\n                        fill: none;\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 1.5;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st6 {\r\n                        stroke: #00AAE6;\r\n                        stroke-width: 2;\r\n                }\r\n\r\n                .st7 {\r\n                        fill: #00AAE6;\r\n                }\r\n\r\n                .stc {\r\n                        fill: #FAF9F7;\r\n                        stroke: #6E625E;\r\n                        stroke-width: 1.5;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .stw {\r\n                        fill: white;\r\n                }\r\n        ")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(0,63)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(0,110)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(149,66.5) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,39.1H1.4v19c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2L75.2,39.1L75.2,39.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,36.1 1.8,58.8 4.2,61 56.2,61 54.6,59 55,34.4 46.2,33.9 46.2,55 43.6,55.5 10.7,55.9 9.2,54.2  9.3,35  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,40.9H1.4v-19c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2L75.2,40.9L75.2,40.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,43.9 1.8,21.2 4.2,19 56.2,19 54.6,21 55,45.6 46.2,46.1 46.2,25 43.6,24.5 10.7,24.1 9.2,25.8  9.3,45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,57.1h1.3c1.2,0,2.1-0.9,2.1-2.1v-2.9c0-1.2-0.9-2.1-2.1-2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 st1",
    d: "M54.8,61.5l-1.7,3.8c-0.7,1.5-2.4,2.1-3.9,1.5l-0.4-0.2l2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,39.8v18c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2v-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,38.5 9.4,55.8 46.2,55.8 46.2,38.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 55.5,
    x2: 2.8,
    y2: 60.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 55.5,
    x2: 54.7,
    y2: 60.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,61.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 39.7,
    x2: 54.8,
    y2: 61.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 60.5,
    x2: 27.9,
    y2: 55.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 15.5,
    y1: 51.5,
    x2: 39.9,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 39.9,
    y1: 51.5,
    x2: 15.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,22.9h1.3c1.2,0,2.1,0.9,2.1,2.1v2.9c0,1.2-0.9,2.1-2.1,2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 st1",
    d: "M54.8,18.5l-1.7-3.8c-0.7-1.5-2.4-2.1-3.9-1.5l-0.4,0.2l2.4,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,40.2v-18c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2v18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,41.5 9.4,24.2 46.2,24.2 46.2,41.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 24.5,
    x2: 2.8,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 24.5,
    x2: 54.7,
    y2: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,18.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 40.3,
    x2: 54.8,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 19.5,
    x2: 27.9,
    y2: 24.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "car2",
    transform: "translate(170,100) scale(0.5) rotate(-15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.2,39.1H1.4v19c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2L75.2,39.1L75.2,39.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,36.1 1.8,58.8 4.2,61 56.2,61 54.6,59 55,34.4 46.2,33.9 46.2,55 43.6,55.5 10.7,55.9 9.2,54.2  9.3,35  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.2,40.9H1.4v-19c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2L75.2,40.9L75.2,40.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,43.9 1.8,21.2 4.2,19 56.2,19 54.6,21 55,45.6 46.2,46.1 46.2,25 43.6,24.5 10.7,24.1 9.2,25.8  9.3,45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,57.1h1.3c1.2,0,2.1-0.9,2.1-2.1v-2.9c0-1.2-0.9-2.1-2.1-2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 st12",
    d: "M54.8,61.5l-1.7,3.8c-0.7,1.5-2.4,2.1-3.9,1.5l-0.4-0.2l2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,39.8v18c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2v-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,38.5 9.4,55.8 46.2,55.8 46.2,38.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 55.5,
    x2: 2.8,
    y2: 60.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 55.5,
    x2: 54.7,
    y2: 60.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,61.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 39.7,
    x2: 54.8,
    y2: 61.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 60.5,
    x2: 27.9,
    y2: 55.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,22.9h1.3c1.2,0,2.1,0.9,2.1,2.1v2.9c0,1.2-0.9,2.1-2.1,2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 st12",
    d: "M54.8,18.5l-1.7-3.8c-0.7-1.5-2.4-2.1-3.9-1.5l-0.4,0.2l2.4,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,40.2v-18c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2v18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,41.5 9.4,24.2 46.2,24.2 46.2,41.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 24.5,
    x2: 2.8,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 24.5,
    x2: 54.7,
    y2: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,18.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 40.3,
    x2: 54.8,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 19.5,
    x2: 27.9,
    y2: 24.7
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#arrow",
    transform: "translate(40,65) rotate(90,40,40) scale(0.5)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#arrow",
    transform: "translate(-30,65) rotate(90,40,40) scale(0.5)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#arrow",
    transform: "translate(40,115) rotate(90,40,40) scale(0.5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3132_18962",
    x: 0.250977,
    y: 0.155273,
    width: 45.9199,
    height: 47.1294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3132_18962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3132_18962",
    result: "shape"
  })), /*#__PURE__*/React.createElement("path", {
    id: "road-lines",
    d: "                         M 0 0                         L 338 0",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeDasharray: "12 10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    className: "stw",
    d: "M33,26 L21,26 L40,7 L59,26 L47,26 L47,74 L33,74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample2);
export default __webpack_public_path__ + "static/media/example2.419c1097e3515d4c319eb64777d9e409.svg";
export { ForwardRef as ReactComponent };